export function getDatasets(state: any) {
    return state.datasetsPage.list.rows;
}

export function getDatasetsMeta(state: any) {
    return state.datasetsPage.list.meta;
}

export function getDatasetsParams(state: any) {
    return state.datasetsPage.listParams;
}

export function getFilterYears(state: any) {
    return state.datasetsPage.filters.years;
}

export function hasMoreDatasets(state: any) {
    const rows = getDatasets(state);
    const meta = getDatasetsMeta(state);

    return meta.totalSize > rows.length;
}

export function isLoading(state: any) {
    return state.datasetsPage.isLoading;
}
